<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">

    export const NavBarDefaults = {
        "name": "navBar",

        "meta": {
            "order": {
                "icon": 1,
                "text": 2,
                "logo": 3,
                "left-button-container": 3.5,
                "left-button-icon": 4,
                "left-button-text": 5,
                "right-button-container": 5.5,
                "right-button-icon": 6,
                "right-button-text": 7,
            }
        },

        "outer-container": { 
            "style": {
                "padding-top": "44px",
                "padding-bottom": "0px",
                "padding-left": "17px",
                "padding-right": "17px",
                "align-items": "center",
                "flex-direction": "row",
                "background-color": "#00000080" 
            }
        },

        "inner-container": {
            "style": {
                "flex-direction": "row",
                "align-items": "center",
                "justify-content": "space-between",
                "height": "44px",
                "width": "100%"
            }
        },

        "logo": {
            "name": "logo",
            "style": {
                "width": "auto", 
                "height": "24px", 
                "border-radius": "0px",
            },
            "src": "../static/image/example-logo.png"
        },

        "left-button-container": {
            "name": "left-button-container",
            "style": {
                "display": "flex",
                "flex-direction": "row",
                "align-items": "center",
            },
            "data-pw-close": "1"
        },

        "right-button-container": {
            "name": "right-button-container",
            "style": {
                "display": "flex",
                "flex-direction": "row",
                "align-items": "center",
            },
            "data-pw-custom": "help"
        },

        "left-button-text": {
            "name": "left-button-text",
            "innerText": "",
            "style": {
                "font-weight": "500"
            }
        },

        "left-button-icon": {
            "name": "left-button-icon",
            "style": {
                "background-color": "black",
                "width": "24px",
                "height": "24px",
                "margin-right": "10px",

            },
            "custom": {
                "icon": {
                    "element": "icon",
                    "value": "xmark.circle.fill",
                    "type": "icon",
                    "style": {
                        "-webkit-mask": "url(../static/symbols/{{value}}.svg) no-repeat center / contain",
                        "mask": "url(../static/symbols/{{value}}.svg) no-repeat center / contain",
                    }
                }
            }
        },

        "right-button-text": {
            "name": "right-button-text",
            "innerText": "",
            "style": {
                "font-weight": "500"
            }
        },



        "right-button-icon": {
            "name": "right-button-icon",
            "style": {
                "background-color": "black",
                "width": "24px",
                "height": "24px",
                "margin-left": "10px",

            },
            "custom": {
                "icon": {
                    "element": "icon",
                    "value": "questionmark.circle.fill",
                    "type": "icon",
                    "style": {
                        "-webkit-mask": "url(../static/symbols/{{value}}.svg) no-repeat center / contain",
                        "mask": "url(../static/symbols/{{value}}.svg) no-repeat center / contain",
                    }
                }
            }
        }

        
    }

    
    
</script>

<script>

</script>



<div class="spacer left">
    <div data-i-name="left-button-container" class="navbar-button-container right">
        <div data-i-name="left-button-icon"/>
        <p data-i-name="left-button-text">Exit</p>
    </div>
</div>

<div class="spacer middle">
    <img class="logo" data-i-name="logo"/>
</div>

<div class="spacer right">
    <div data-i-name="right-button-container" class="navbar-button-container left">
        <p data-i-name="right-button-text">Help</p>
        <div data-i-name="right-button-icon"/>
    </div>
</div>



<style>

.spacer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.spacer.left {
    width: 45%;
    white-space: nowrap;
    /* position: relative; */
    align-items: flex-start;
    justify-content: flex-start;
}

.spacer.right {
    width: 45%;
    white-space: nowrap;
    align-items: flex-end;
    justify-content: flex-end;
}

.spacer.middle {
    position: relative;
    margin-left: -50vw;
    margin-right: -50vw;
}

</style>